import { createSlice } from '@reduxjs/toolkit';
import { occyLs } from '../utils/localStorage';

const isReadOnly = occyLs.getObject('isReadOnly') || false;
const forceLogin = occyLs.getObject('forceLogin') || false;

const slice = createSlice({
  name: 'isReadOnly',
  initialState: {
    isReadOnly: isReadOnly,
    forceLogin: forceLogin,
  },
  reducers: {
    setOOOPermission: (state, { payload }) => {
      state.isReadOnly = { payload };
      occyLs.setObject('isReadOnly', payload);
    },
    setForceLoginPermission: (state, { payload }) => {
      state.forceLogin = { payload };
      occyLs.setObject('forceLogin', payload);
    },
  },
});

export const { setOOOPermission,setForceLoginPermission } = slice.actions;

export default slice.reducer;

export const getOOOPermissionState = (state) => state.readOnly.isReadOnly;
export const getForceLoginPermissionState = (state) => state.readOnly.forceLogin;

